import { getRequest } from './index';
import apiEndpoints from './apiEndpoints';

export const getCountries = () => getRequest(apiEndpoints.countries);
